import { Constructable } from './types';

/**
 * Ensures only one instance is created even when used across multiple js bundles.
 */
export function singletonGlobal<T extends Constructable>(
    key: string,
    constr: T
): (...args: ConstructorParameters<T>) => InstanceType<T> {
    const symbol = Symbol.for(key);
    return (...args) => {
        if (!window[symbol]) {
            window[symbol] = new constr(...args);
        }
        return window[symbol];
    };
}
